'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require('revalidate');

var _emailValidator = require('email-validator');

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var isValidUrl = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (value && !/^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/i.test(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var validate = (0, _revalidate.combineValidators)({
  manufacturerLink: (0, _revalidate.composeValidators)(isValidUrl)('Company Link'),
  assetLink: (0, _revalidate.composeValidators)(isValidUrl)('Asset Link')
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/ManageManufacturerValidation.js
// module id = 2571
// module chunks = 0